<template>
  <a
    v-if="donwloadUrl && !isChannel"
    :href="donwloadUrl"
    target="_blank"
    :class="$style.download"
  />
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BtnDownload",
  computed: {
    ...mapGetters(["donwloadUrl", "isChannel"])
  }
};
</script>

<style module lang="less">
.download {
  .size(2.88rem, 0.85rem);
  .background-fill("./images/download-btn.png");
}
</style>
